import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

const pageContainerSizes = {
  sm: 'max-w-3xl',
  md: 'max-w-5xl',
  lg: 'max-w-7xl',
  full: 'max-w-none',
} as const

export interface PageContainerProps {
  children: ReactNode
  size?: keyof typeof pageContainerSizes
  className?: string
}

function PageContainer({ children, size = 'lg', className }: PageContainerProps) {
  return (
    <div className={cn('mx-auto w-full px-4 sm:px-6 lg:px-8', pageContainerSizes[size], className)}>
      {children}
    </div>
  )
}

export { PageContainer }